import APIService from './APIService';

export default {
  index() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('importacoes-xml/dados')
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  },
  save(data) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .post('importacoes-xml/dados/salvar', JSON.stringify(data))
        .then(() => resolve(true))
        .catch(() => reject(false));
    });
  },
  getLogsImportacao(id) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(`importacoes-xml/dados/logs/${id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  },
  baixarLogsTecnicos(id) {
    return APIService.apiCall().get(`importacoes-xml/dados/logs-tecnicos/${id}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  }
};
